import React, { Fragment, FunctionComponent } from 'react';
import { Typography } from '@rbx/ui';
import OpenCloudTypeReference from './OpenCloudTypeReference';
import OpenCloudObjectReference from './OpenCloudObjectReference';
import useObjectReferenceUtils from '../../../context/hooks/useObjectReferenceUtils';
import type { OpenCloudAPISchema } from '../../../utils/oasTypes';

interface OpenCloudTypeProps {
  schema: OpenCloudAPISchema;
}

const OpenCloudType: FunctionComponent<React.PropsWithChildren<OpenCloudTypeProps>> = ({
  schema,
}) => {
  const { dereference, isObjectReference } = useObjectReferenceUtils();

  if (schema === null) {
    return null;
  }

  if (isObjectReference(schema)) {
    const objectReference = dereference(schema);

    if (objectReference === null) {
      throw new Error('Unknown object reference!');
    }
    return <OpenCloudObjectReference objectName={objectReference.name} />;
  }

  if (schema.type === null || schema.type === undefined) {
    return null;
  }

  const { type } = schema;

  if (type === 'array') {
    if (schema.items === null) {
      return <OpenCloudTypeReference type={type} />;
    }
    return (
      <Fragment>
        <OpenCloudTypeReference type={type} />
        <Typography variant='code' color='secondary'>
          {'<'}
        </Typography>
        <OpenCloudType schema={schema.items} />
        <Typography variant='code' color='secondary'>
          {'>'}
        </Typography>
      </Fragment>
    );
  }

  return <OpenCloudTypeReference type={type} />;
};

export default OpenCloudType;
